import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const LAB_REPORT_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  INTERNAL_LAB_REPORT: {
    id: "INTERNAL_LAB_REPORT",
    title: "Internal",
    RBACDescription: "Access to view lab report management.",
    RBACDisplayName: "INTERNAL_LAB_REPORT_MANAGEMENT",
    icon: "BsCardChecklist",
    path: "internal",
    url: "/app/lab-report/internal",
    isVirtual: false,
    children: {},
  },
  EXTERNAL_LAB_REPORT: {
    id: "EXTERNAL_LAB_REPORT",
    title: "External",
    RBACDescription: "Access to view lab report management.",
    RBACDisplayName: "EXTERNAL_LAB_REPORT_MANAGEMENT",
    icon: "BsCardChecklist",
    path: "external",
    url: "/app/lab-report/external",
    isVirtual: false,
    children: {},
  },
  INCOMING_LAB_REPORT: {
    id: "INCOMING_LAB_REPORT",
    title: "Incoming",
    RBACDescription: "Access to view lab report management.",
    RBACDisplayName: "INCOMING_LAB_REPORT",
    icon: "BsCardChecklist",
    path: "incoming",
    url: "/app/lab-report/incoming",
    isVirtual: false,
    children: {},
  },

  // ── RBAC virtual features (lab-report-scoped) ────────────────────
  LAB_REPORT_TAT_VIEW: {
    id: "LAB_REPORT_TAT_VIEW",
    title: "lab report tat view",
    path: "cta",
    RBACDisplayName: "LAB_REPORT_TAT_VIEW",
    RBACDescription: "Lab Report table — service desk TAT-focused view.",
    url: "/app/lab-report/tat-view-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  LAB_REPORT_CLINIC_VIEW: {
    id: "LAB_REPORT_CLINIC_VIEW",
    title: "lab report clinic view",
    path: "cta",
    RBACDisplayName: "LAB_REPORT_CLINIC_VIEW",
    RBACDescription: "Lab Report table — clinic-side view (clinic ops variants).",
    url: "/app/lab-report/clinic-view-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  LAB_REPORT_RETEST: {
    id: "LAB_REPORT_RETEST",
    title: "lab report retest",
    path: "cta",
    RBACDisplayName: "LAB_REPORT_RETEST",
    RBACDescription: "Lab Report table — Re-test option on internal requisitions.",
    url: "/app/lab-report/retest-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
};

export const CLINIC_LAB_REPORT_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  LAB_PARTNER_ONBOARD: {
    id: "LAB_REPORT_CREATION",
    title: "Lab Report Creation",
    description: "Access to Lab Report",
    path: "lab-partner-onboard",
    url: "/app/clinic-lab-report/lab-partner-onboard",
    children: {},
  },
  LAB_PARTNER_LIST: {
    id: "LAB_PARTNER_LIST",
    title: "Lab Report Details",
    description: "Access to Lab Report Details",
    path: "lab-partner-list",
    url: "/app/clinic-lab-report/lab-partner-list",
    children: {},
  },
  LAB_PARTNER_CLINIC_LIST: {
    id: "LAB_PARTNER_CLINIC_LIST",
    title: "Lab Report Details",
    description: "Access to Lab Report Details",
    path: "lab-partner-clinic-list",
    url: "/app/clinic-lab-report/lab-partner-clinic-list",
    children: {},
  },
  LAB_PARTNER_CLINIC_MAPPING: {
    id: "LAB_PARTNER_CLINIC_MAPPING",
    title: "Lab Report Details",
    description: "Access to Lab Report Details",
    path: "lab-partner-clinic-mapping",
    url: "/app/clinic-lab-report/lab-partner-clinic-mapping",
    children: {},
  },
  LAB_PARTNER_ONBOARDING: {
    id: "LAB_PARTNER_ONBOARDING",
    title: "LAB_PARTNER_ONBOARDING",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "lab consfiguration ",
    icon: "BsCardChecklist",
    path: "lab-partner-clinic-mapping-l",
    url: "/app/clinic-lab-report/lab-partner-clinic-mapping-l",
    isVirtual: true,
    children: {},
  },
};

export const LAB_REPORT_INTERPRETATION_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
    LAB_REPORT_INTERPRETATION_LIST: {
      id: "LAB_REPORT_INTERPRETATION_LIST",
      title: "Interpretation List",
      RBACDescription: "Access to fill lab report interpretation.",
      RBACDisplayName: "LAB_REPORT_INTERPRETATION_LIST",
      icon: "BsCardChecklist",
      path: "list",
      url: "/app/lab-report-interpretation/list",
      isVirtual: false,
      children: {},
    },
};
